import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Activity } from "react";
import { Box } from "@vk-hr-tek/ui/Box";
import { ToTopButton } from "@vk-hr-tek/ui/ToTopButton";
import { useScrollToTop } from "@vk-hr-tek/ui/hooks";
import { useStyles } from "./ContainerWithScrollToTopButton.styles.js";
const ContainerWithScrollToTopButton = (t0)=>{
    const $ = c(14);
    const { scrollMargin, children } = t0;
    let t1;
    if ($[0] !== scrollMargin) {
        t1 = {
            scrollMargin
        };
        $[0] = scrollMargin;
        $[1] = t1;
    } else t1 = $[1];
    const { classes } = useStyles(t1);
    const { containerRef, showScrollButton, scrollToStart } = useScrollToTop();
    let t2;
    if ($[2] !== classes.scrollTarget || $[3] !== containerRef) {
        t2 = /*#__PURE__*/ jsx(Box, {
            className: classes.scrollTarget,
            ref: containerRef,
            position: "absolute",
            width: 20,
            height: 20,
            top: 0
        });
        $[2] = classes.scrollTarget;
        $[3] = containerRef;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = showScrollButton ? "visible" : "hidden";
    let t4;
    if ($[5] !== scrollToStart) {
        t4 = /*#__PURE__*/ jsx(ToTopButton, {
            scrollToStart: scrollToStart
        });
        $[5] = scrollToStart;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3 || $[8] !== t4) {
        t5 = /*#__PURE__*/ jsx(Activity, {
            mode: t3,
            children: t4
        });
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== children || $[11] !== t2 || $[12] !== t5) {
        t6 = /*#__PURE__*/ jsxs(Box, {
            children: [
                t2,
                children,
                t5
            ]
        });
        $[10] = children;
        $[11] = t2;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
};
export { ContainerWithScrollToTopButton };
